/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sharelinkvisits2Inputs */

const en_sharelinkvisits2 = /** @type {(inputs: Sharelinkvisits2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Visits: ${i?.count}`)
};

const de_sharelinkvisits2 = /** @type {(inputs: Sharelinkvisits2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Besuche: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Visits: {count}" |
*
* @param {Sharelinkvisits2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharelinkvisits2 = /** @type {((inputs: Sharelinkvisits2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharelinkvisits2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharelinkvisits2(inputs)
	return de_sharelinkvisits2(inputs)
});
export { sharelinkvisits2 as "shareLinkVisits" }